import React from 'react';
import { useHistory } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { ReactComponent as ClockIcon } from 'src/new/components/icons/fi-rr-clock.svg';
import { Button } from 'new/elements/Button';
import { Nexset } from 'new/entities/Nexset';
import { isReadOnly } from 'js/lib/ACLUtils';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { ROUTE_MY_DATA_SETS } from 'js/constants/pathnames';
import { useModals } from 'new/hooks/useModals';
import { ModalRequestAccess } from 'new/elements/ModalRequestAccess/ModalRequestAccess';
import { useMarketplaceRequests } from 'new/hooks/adapters/useMarketplaceRequests';
import { RESOURCE_TYPE_DATA_SET } from 'js/constants/resourceTypes';
import useResourceEditProvider from 'js/components/ResourceEditProvider/useResourceEditProvider';
import { editModalsEnabled } from 'new/constants/featureFlags';

interface DomainItemActionsProps {
  domainId: number;
  item: Nexset;
  /**
   * @DOC
   *    inDrawer boolean used to determine action button styling for detail panel
   * @param inDrawer
   */
  inDrawer?: boolean;
}

export const DomainItemActions = (props: DomainItemActionsProps) => {
  const { domainId, item, inDrawer = false } = props;
  const history = useHistory();
  const { openModal } = useModals();
  const { outgoingAccessRequests: accessRequests } = useMarketplaceRequests();
  const { setAction } = useResourceEditProvider();

  const hasAccess = !isReadOnly(item);
  const isPending =
    !hasAccess &&
    accessRequests.some(
      (request) => request?.data_set?.id === item?.id && request?.status === 'pending',
    );

  const onClickRequest = () => {
    openModal(ModalRequestAccess.modalConfig.name, {
      item,
      domainId,
    });
  };

  const handleOnUsaDaraProductClick = () => {
    const isModalModeEnabledForNexset = !!editModalsEnabled()?.nexset;

    if (isModalModeEnabledForNexset) {
      setAction({
        id: item?.id,
        type: 'create',
        flowType: item?.flow_type,
        resource: RESOURCE_TYPE_DATA_SET,
      });
      return;
    }

    history.push(`${ROUTE_CONNECT}${ROUTE_MY_DATA_SETS}/${item?.id}/new`);
  };

  return (
    <>
      {hasAccess ? (
        <Button
          variant="outlined"
          color={inDrawer ? 'primary' : 'secondary'}
          style={inDrawer ? { backgroundColor: 'white' } : null}
          onClick={handleOnUsaDaraProductClick}
        >
          Use Data Product
        </Button>
      ) : (
        <>
          {isPending ? (
            <Stack alignItems="center" direction="row" gap="6px" padding="4px">
              <ClockIcon />
              <Typography variant="body2">Request Pending</Typography>
            </Stack>
          ) : (
            <Button
              variant={inDrawer ? 'outlined' : 'ghost'}
              color="primary"
              style={inDrawer ? { backgroundColor: 'white' } : null}
              onClick={onClickRequest}
            >
              Request Access
            </Button>
          )}
        </>
      )}
    </>
  );
};
